/**
 * @description 定义全局变量
 */

// 全局状态类型的变量集合
export const GLOBAL_STATUS = {
    // SCENE_TYPE_MAP: {
    //     1: '输电',
    //     2: '配网',
    //     3: 'CAAC',
    //     4: '变电',
    // } as Record<number, string>,
};

// 全局配置类型的变量集合
export const GLOBAL_CONFIG = {
    // 图片根路径
    FILE_ROOT_PATH: process.env.VUE_APP_FILE_URL,
    // 引擎名称
    ENGINE_NAME: "uavSimulatorEngine",
    ENGINE_API: "EnginApi",
};


// 全局枚举类型的变量集合
export namespace GLOBAL_ENUM {
    // 通用状态, 比如：锁定状态， 遥控器连接状态， 音频状态等
    export enum SWITCH_STATUS {
        ON = 1,
        OFF = 0,
    }

    // 飞行状态
    export enum UAV_FLY_STATUS {
        WAITING = 0, // 等待
        FLYING = 1, // 飞行中
        BACKING = 2, // 返航中
    }

    // 音频模式
    export enum AUDIO_MODE {
        PHOTO = 0, // //拍照
        VIDEO = 1, // 视频
    }

    //请求配置
    export enum EnumResult {
        SUCCESS = 10000,
        ERROR = 500000,
        OVERDUE = 10401,
    }

    export enum CommonStatus {
        open = 1, // 开启
        close = 0, // 关闭
    }

    export enum FlyDeviationViewMode {
        卡片='card',
        曲线='line'
    }

    // 课程类型
    export enum CourseTypeEnum {
        CAAC多旋翼 = 1,
        电力巡检 = 3,
    }

    // 场景类型
    export enum SceneCategoryEnum {
        科目训练 = 2,
        通关测试 = 4,
        模拟考核 = 1,
    }
}

//全局提示
export const GLOBAL_TIPS = {
    //开机提示
    OPEN_TIPS: "控制摇杆外八或内八解锁无人机后，开始飞行。",
}




